import React from "react";
import LogoSVG from "../../assets/icons/logo.svg";
import { Menu as MenuIcon } from '@mui/icons-material';

interface HeaderProps {
    userName?: string;
    tenantName?: string;
    onLogout?: () => void;
    onMenuClick?: () => void;
    showMenuButton?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ userName, tenantName, onLogout, onMenuClick, showMenuButton = false }) => {
    return (
        <header
            style={{
                height: 60,
                backgroundColor: "#EBF5F5",
                borderBottom: "1px solid #B4D9D4",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 24px",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                width: "100%",
                boxSizing: "border-box",
                zIndex: 1100,
            }}
        >
            {/* Logo and Menu Button */}
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                {showMenuButton && onMenuClick && (
                    <button
                        onClick={onMenuClick}
                        style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <MenuIcon sx={{ color: "#284C58", fontSize: 24 }} />
                    </button>
                )}
                <img
                    src={LogoSVG}
                    alt="PREDICTIX"
                    style={{ height: 32, width: "auto" }}
                />
            </div>

            {/* User Info */}
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                {tenantName && (
                    <span
                        style={{
                            fontSize: 14,
                            color: "#284C58",
                            fontWeight: 600,
                        }}
                    >
                        {tenantName}
                    </span>
                )}
                {tenantName && userName && (
                    <span style={{ color: "#B4D9D4", fontSize: 14 }}>|</span>
                )}
                {userName && (
                    <span
                        style={{
                            fontSize: 14,
                            color: "#374151",
                            fontWeight: 500,
                        }}
                    >
                        {userName}
                    </span>
                )}
                {onLogout && (
                    <button
                        onClick={onLogout}
                        style={{
                            padding: "6px 12px",
                            fontSize: 14,
                            fontWeight: 500,
                            color: "#374151",
                            backgroundColor: "transparent",
                            border: "1px solid #d1d5db",
                            borderRadius: 6,
                            cursor: "pointer",
                            transition: "all 0.2s",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#f3f4f6";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "transparent";
                        }}
                    >
                        Logout
                    </button>
                )}
            </div>
        </header>
    );
};
